import { ArnIfComponent } from '../if/ArnIfComponent';

export class ArnIfHasComponent extends ArnIfComponent {
  static readonly ATTR_TAGS = 'tags';
  static readonly ATTR_ERC721 = 'nft-from';
  static readonly ATTRS = [
    ArnIfHasComponent.ATTR_TAGS,
    ArnIfHasComponent.ATTR_ERC721,
  ];

  static override get observedAttributes() {
    return ArnIfHasComponent.ATTRS;
  }

  protected override setInitial() {
    super.setInitial(ArnIfHasComponent.observedAttributes);
  }

  protected normalizeTag(tag: string): string {
    let normalized = tag.trim();
    while (['"', ' ', "'"].includes(normalized.charAt(0))) {
      normalized = normalized.substring(1);
    }
    while (['"', ' ', "'"].includes(normalized.charAt(normalized.length - 1))) {
      normalized = normalized.substring(0, normalized.length - 1);
    }
    return normalized.trim();
  }

  override attributeChangedCallback(
    name: string,
    _oldValue: string | null,
    newValue: string | null
  ) {
    if (newValue) {
      switch (name) {
        case ArnIfHasComponent.ATTR_TAGS:
          {
            const tags = this.getTagsFromAttribute(newValue);
            this.setTags(...tags);
          }
          break;
        case ArnIfHasComponent.ATTR_ERC721:
          {
            const contract = this.getAddrFromAttribute(newValue);
            this.setErc721(contract);
          }
          break;
      }
    } else {
      this.updateUI(false);
    }
  }

  protected override updateUI(isTrue: boolean) {
    super.updateUI(isTrue);
  }

  protected getTagsFromAttribute(tagAttr: string | null): string[] {
    return tagAttr ? tagAttr.split(',').map(this.normalizeTag) : [];
  }

  async setTags(...tags: string[]) {
    const hasTags = await this.arnClient.condition.arianee.hasNftWithTags(
      ...tags
    );
    this.updateUI(hasTags);
  }

  async setErc721(contract: string) {
    const owns = await this.arnClient.condition.erc721.isOwnedFrom(contract);
    this.updateUI(owns);
  }

  private getAddrFromAttribute(erc721Attr: string | null): string {
    return (erc721Attr || '').trim();
  }
}

const name = 'arn-if-has';
if (!window.customElements.get(name)) {
  window.customElements.define(name, ArnIfHasComponent);
}
